<template>
  <StageScaler>
    <RoomsStage
      data-testid="rooms-stage"
      :logo="$store.getters['branding/theme_obj'].logo_url"
      :demoButtonText="$store.getters['branding/theme_obj'].demo_request_button_text"
      :showDemoLink="$store.getters['branding/theme_obj'].demo_link_enabled"
      :targets="$store.getters['branding/currentTargets']"
      :showPinnedMessages="currentModuleId === 'agendaBackground' || currentModuleId === 'PopupWindows'"
      :showChatOnMobile="
        (currentModuleId === 'agendaBackground' || currentModuleId === 'PopupWindows') && currentView === 'cellphone'
      "
      :navigatorLinks="$store.getters['branding/navigatorLinks']"
      :stageChatTabs="$store.getters['branding/stageChatTabs']"
      :sidebarPrimaryTabs="$store.getters['branding/sidebarPrimaryTabs']"
    />
  </StageScaler>
</template>

<script>
import { RoomsStage } from '@goldcast/uicomponents-branding';
import { mapState } from 'vuex';

import StageScaler from './StageScaler.vue';

export default {
  name: 'RoomsStagePreview',
  components: { RoomsStage, StageScaler },
  computed: {
    ...mapState('branding', ['currentModuleId', 'currentView'])
  }
};
</script>
